module.exports = require("!!vue-loader!../node_modules/v-markdown-loader/_cache/vux-loader-5.vue");


//////////////////
// WEBPACK FOOTER
// ./en/vux-loader.md
// module id = 622
// module chunks = 196